import React from 'react';
import { Redirect } from 'react-router-dom';

const RedirectAdmissao = () => {
  // Valores fixos para admissao: companyId = "Mw==", modelId = "MjMx"
  const companyId = 'Mw==';
  const modelId = 'MjMx';

  localStorage.setItem('@Diretiva:process:companyId', companyId);
  localStorage.setItem('@Diretiva:process:modelId', modelId);

  return <Redirect to="/admissao/signin" />;
};

export default RedirectAdmissao;
